import { useCaptureStatusPolling } from 'components/newIdentifyMethods/VideoScreen/VideoScreenDispatcher/VideoSelfie/hooks/finishCapture/useCaptureStatusPolling';
import { finishCapture } from 'components/newIdentifyMethods/VideoScreen/VideoScreenDispatcher/VideoSelfie/utils/requests/finishCapture';

export const useFinishCapture = ({ onComplete, onError }) => {
    const startStatusPolling = useCaptureStatusPolling({
        onComplete,
        onError,
    });

    return () => {
        void finishCapture({
            onComplete: startStatusPolling,
            onError,
        });
    };
};
